import { Outlet } from 'react-router-dom';
import { ContextBar } from './ContextBar';
import { ToolRail } from './ToolRail';
import '../../styles/shell.css';

export function AppShell() {
  return (
    <div className="app-shell">
      <ContextBar />
      <div className="split-pane">
        <ToolRail density="sidebar" />
        <main className="screen-panel">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
